var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogoSm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 179,
    viewBox: "0 0 180 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2187 153.465C35.8596 146.687 34.5268 139.97 33.1062 132.85C32.2294 133.604 31.6769 134.025 31.1684 134.473C24.8111 139.953 18.4188 145.398 12.1229 150.958C11.4659 151.645 10.5935 152.086 9.65085 152.209C8.70816 152.332 7.75184 152.128 6.94068 151.633C4.19823 150.277 1.96361 148.076 0.565872 145.354C-0.424982 143.39 -0.135624 142.294 1.60056 140.97L25.5915 122.144L27.6785 120.469C26.5298 118.373 25.4512 116.251 24.2324 114.217C21.7333 110.052 18.9712 106.036 16.6914 101.748C15.287 98.8138 14.1597 95.7549 13.3242 92.6111C12.8332 91.024 13.5785 89.6122 14.7798 88.3583C28.3537 74.2583 44.9352 65.7089 63.9368 61.6666C75.3093 59.2213 87.0484 59.0069 98.5027 61.0352L37.5519 112.113L37.7887 112.463C38.2798 112.113 38.7795 111.771 39.2531 111.402L134.042 37.0618C135.033 36.2726 136.146 35.1502 137.365 36.1148C138.383 36.9045 139.076 38.0402 139.312 39.3066C139.267 39.9039 139.104 40.4864 138.834 41.0207C138.563 41.5549 138.189 42.0303 137.733 42.4194C129.044 50.0394 120.38 57.6856 111.428 65.0425C108.218 67.6731 106.631 70.1546 107.043 74.688C108.008 85.0438 107.797 95.5573 110.735 105.632C112.375 111.236 114.891 116.585 117.013 122.047C117.215 122.556 117.399 123.073 117.513 123.363L82.0439 135.928L82.2369 136.595C82.649 136.498 83.0699 136.428 83.482 136.305C97.6258 132.245 111.892 128.755 126.527 126.958C133.674 126.081 140.855 125.327 148.028 126.747C149.201 126.978 150.336 127.367 151.404 127.905C153.894 129.15 154.657 131.228 153.096 133.534C151.675 135.607 149.972 137.472 148.037 139.076C142.407 143.732 135.989 147.152 129.438 150.291C104.948 162.015 79.273 170.17 52.7129 175.624C42.9972 177.614 33.2027 179.193 23.2415 178.982C20.2832 178.944 17.3398 178.556 14.4729 177.825C9.96583 176.641 8.99254 173.607 11.9826 170.064C13.8211 167.817 15.9879 165.86 18.41 164.26C23.8904 160.752 29.6163 157.709 35.2458 154.474C35.8245 154.158 36.4471 153.869 37.2187 153.465ZM32.3784 174.51V174.65C34.0094 174.484 35.6491 174.361 37.2713 174.142C39.332 173.87 41.4014 173.589 43.4094 173.177C69.6655 167.91 95.3555 160.134 120.126 149.958C125.725 147.512 131.197 144.788 136.523 141.794C137.549 141.251 138.137 139.883 138.926 138.892C137.733 138.506 136.506 137.699 135.348 137.805C130.644 138.105 125.96 138.67 121.319 139.497C97.0185 144.487 73.2068 151.614 50.1612 160.796C44.4265 163.058 38.8672 165.794 33.2816 168.442C31.6103 169.326 30.0352 170.381 28.5816 171.59C28.0555 171.993 27.8538 172.818 27.5031 173.458C28.1519 173.886 28.8534 174.228 29.59 174.475C30.5165 174.572 31.4498 174.584 32.3784 174.51Z",
    fill: "url(#paint0_linear_4207_657)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.61 24.0439L108.735 29.4164L113.8 31.5333L109.041 34.2706L108.596 39.7379L104.523 36.0517L99.1795 37.3218L101.428 32.3143L98.5737 27.6207L104.034 28.212L107.61 24.0439Z",
    fill: "url(#paint1_linear_4207_657)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.824 22.4404L170.432 33.8045L179.516 40.5731L168.657 43.7169L165.075 54.4969L158.754 45.0741L147.46 44.971L154.412 36.0034L151.017 25.1633L161.628 29.0458L170.824 22.4404Z",
    fill: "url(#paint2_linear_4207_657)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28 3.97289L133.258 10.4154L141.358 9.99371L136.81 16.6894L139.763 24.2681L131.972 21.9637L125.701 27.0688L125.434 18.949L118.608 14.5263L126.231 11.8162L128.28 3.97289Z",
    fill: "url(#paint3_linear_4207_657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4207_657",
    x1: 76.5977,
    y1: 35.7422,
    x2: 73.4372,
    y2: 174.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#849CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4207_657",
    x1: 106.152,
    y1: 24.0439,
    x2: 105.769,
    y2: 39.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#849CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4207_657",
    x1: 163.414,
    y1: 22.4404,
    x2: 162.654,
    y2: 53.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#849CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4207_657",
    x1: 124.196,
    y1: 7.35961,
    x2: 137.927,
    y2: 24.7693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#849CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB93FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoSm2);
export default __webpack_public_path__ + "static/media/new-logo-sm-2.c661e1584d70d1237bf7041eda4d24b9.svg";
export { ForwardRef as ReactComponent };